// extracted by mini-css-extract-plugin
export default {"player":"audio-player_player__QU56l","fullWidth":"audio-player_fullWidth__nirr1","removeBtn":"audio-player_removeBtn__W3efr","recorder":"audio-player_recorder__CL0D4"};